import { Injectable, signal, computed } from '@angular/core';
import { Staff } from '@ew/models';

@Injectable({ providedIn: 'root' })
export class MobileGlobalStaffStore {
  private staffData = signal<Staff | null>(null);
  private token = signal<string | null>(null);

  staff = computed(() => this.staffData());
  isAuthenticated = computed(() => !!this.token() && !!this.staffData());

  constructor() {
    // Load from storage after DI completes to avoid circular dependency
    this.staffData.set(this.loadFromStorage());
    this.token.set(localStorage.getItem('staffToken'));
  }

  getToken(): string | null {
    return this.token();
  }

  setStaffData(staff: Staff): void {
    this.staffData.set(staff);
    localStorage.setItem('staffData', JSON.stringify(staff));
  }

  setToken(token: string): void {
    this.token.set(token);
    localStorage.setItem('staffToken', token);
  }

  updateProfile(updates: Partial<Staff>): void {
    const current = this.staffData();
    if (current) {
      const updated = { ...current, ...updates };
      this.setStaffData(updated as Staff);
    }
  }

  logout(): void {
    this.staffData.set(null);
    this.token.set(null);
    localStorage.removeItem('staffData');
    localStorage.removeItem('staffToken');
  }

  private loadFromStorage(): Staff | null {
    try {
      const stored = localStorage.getItem('staffData');
      // Check if stored value exists and is not the string "undefined" or "null"
      if (stored && stored !== 'undefined' && stored !== 'null') {
        return JSON.parse(stored);
      }
    } catch (error) {
      console.error('Failed to parse staff data from localStorage:', error);
      // Clear corrupted data
      localStorage.removeItem('staffData');
    }
    return null;
  }
}
